import { Box, Stack, styled, Typography, Link } from '@mui/material'
import { Security } from '@mui/icons-material'
import { Link as RouterLink } from 'react-router-dom'
import { useRoles } from '../../utils/hooks/useRoles'

const CancelIconContainer = styled('div')`
  width: 96px;
  height: 96px;
  display: flex;
  justify-content: center;
  align-items: center;

  .icon {
    transform: scale(2);
  }

  svg {
    fill: #d13e43;
  }
`

export function NoPermission() {
  const { isSuperAdmin } = useRoles()

  return (
    <Stack
      width="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Box display="flex" alignItems="center">
        <CancelIconContainer>
          <Security className="icon" />
        </CancelIconContainer>
      </Box>

      {isSuperAdmin ? (
        <Box>
          <Typography fontSize="24px">
            This module is currently{' '}
            <strong>disabled in System Settings</strong>.
          </Typography>
          <Typography fontSize="24px">
            You can enable it by visiting{' '}
            <Link
              component={RouterLink}
              to="/system_settings"
              underline="hover"
              fontWeight="bold"
            >
              System Settings
            </Link>
            .
          </Typography>
        </Box>
      ) : (
        <Box>
          <Typography fontSize="24px">
            No modules have been assigned to you yet or you don't have
            permission to view this page.
          </Typography>
          <Typography fontSize="24px">
            Please contact your Manna system administrator to get started!
          </Typography>
        </Box>
      )}
    </Stack>
  )
}
